import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import google from "../assets/login-google.png";
// import facebook from "../assets/login-facebook.png";
// import atlassian from "../assets/login-atlassian.png";
// import slack from "../assets/login-slack.png";
// import apple from "../assets/login-apple.png";

import { LoginSocialGoogle } from "reactjs-social-login";

import "./SocialLogin.scss";

export default function SocialLogin({ api, setAccount, navigate, setLoading }) {
  const { pathname } = useLocation();

  const handleLogin = (googleToken) => {
    setLoading(true);

    api("api/auth/convert-token", {
      method: "POST",
      body: {
        token: googleToken.credential,
        backend: "google-identity",
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        grant_type: "convert_token",
      },
    }).then(({ ok }) => {
      if (ok) {
        api(`api/providers/${process.env.REACT_APP_SLUG}/users/me/`).then(
          ({ ok, body }) => {
            if (ok) {
              setAccount(body?.data);
              navigate("/");
            }
            setLoading(false);
          },
        );
      }
    });
  };
  
  const onReject = (r) => {
    console.warn(r);
  };

  const clearCookieGoogle = () => {
    document.cookie = `g_state=; expires=${new Date()}`;
  }

  useEffect(() => {
    clearCookieGoogle()
  }, [])

  return (
    <div className="socials-login">
      <p>
        <span>
          {pathname === "/register" ? "or sign up with" : "or continue with"}
        </span>
      </p>
      <div className="socials">
        <LoginSocialGoogle
          typeResponse={"idToken"}
          isOnlyGetToken={true}
          client_id={process.env.REACT_APP_OAUTH2_GOOGLE_KEY || ""}
          onResolve={({ provider, data }) => handleLogin(data)}
          scope="openid profile email"
          onReject={(err) => onReject(err)}
          cookie_policy={window.location.href}
        >
          <button className="bw-event-btn" onClick={clearCookieGoogle}>
            <img src={google} alt="google" />
          </button>
        </LoginSocialGoogle>

        {/* <button className="bw-event-btn">
          <img src={facebook} alt="facebook" />
        </button>
        <button className="bw-event-btn">
          <img src={atlassian} alt="atlassian" />
        </button>
        <button className="bw-event-btn">
          <img src={slack} alt="slack" />
        </button>
        <button className="bw-event-btn">
          <img src={apple} alt="apple" />
        </button> */}
      </div>

      {pathname === "/register" ? (
        <h4>
          <span>Already have an account?</span>
          <Link to="/login" className="bw-event-link">
            Log in
          </Link>
        </h4>
      ) : (
        <h4>
          <span>New user?</span>
          <Link to="/register" className="bw-event-link">
            Sign up
          </Link>
        </h4>
      )}
    </div>
  );
}
